export default "__VITE_PUBLIC_ASSET__4e8d9630__"